// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"c7e36581","484":"14cb0921","828":"6cc522b3","869":"b6dda42b","974":"87dcfbc9"}[chunkId] + ".chunk.js";
};